import { PersonLanguageEnum } from "src/app/shared/Models/enums/PersonLanguageEnum";
import { PersonPersonTypeEnum } from "src/app/shared/Models/enums/PersonPersonTypeEnum";

export class DocumentContactDTO {
  id: string;
  name: string;
  phone: string;
  email: string;
  language: PersonLanguageEnum;
  type: PersonPersonTypeEnum;
  city: string;
  number: number;
  postalCode: number;
  street: string;
  suffix: string;

  constructor(dto: Partial<DocumentContactDTO>) {
    Object.assign(this, dto);
  }
}
